/**
 * @generated SignedSource<<a0763b1c864763c4e4f8dfa8986425e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateZendeskJwtInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateZendeskJwtMutation$variables = {
  input: CreateZendeskJwtInput;
};
export type CreateZendeskJwtMutation$data = {
  readonly createZendeskJwt: {
    readonly jwt: string | null;
  } | null;
};
export type CreateZendeskJwtMutation = {
  variables: CreateZendeskJwtMutation$variables;
  response: CreateZendeskJwtMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateZendeskJwtPayload",
    "kind": "LinkedField",
    "name": "createZendeskJwt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jwt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateZendeskJwtMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateZendeskJwtMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "982f64d2940197df1c6ebf44d4e6cf08",
    "id": null,
    "metadata": {},
    "name": "CreateZendeskJwtMutation",
    "operationKind": "mutation",
    "text": "mutation CreateZendeskJwtMutation(\n  $input: CreateZendeskJwtInput!\n) {\n  createZendeskJwt(input: $input) {\n    jwt\n  }\n}\n"
  }
};
})();

(node as any).hash = "66263505b25e3cd5d5c47d13c7d63b92";

export default node;
